import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const customerContractParamsSchema = object({
  customerContractId: stringToNumber()
})
